import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaders: any[]
  public isLoading = new BehaviorSubject<boolean>(false)
  public loaderText: string

  constructor() { 
    this.loaders = []
    this.loaderText = 'Cargando..'
  }

  public async show(msg?: string): Promise<void> {
    this.loaders.push(`loader${this.loaders.push.length + 1}`)
    this.loaderText = (msg != undefined && msg != null && msg.trim().length > 0 ? msg: 'Cargando...')
    this.isLoading.next(this.loaders.length > 0)
  }

  public async hide(): Promise<void> {
    if (this.loaders.push.length > 0) this.loaders.pop()
    this.isLoading.next(this.loaders.length > 0)
  }

  public async hideAll(): Promise<void> {
    this.loaders = []
    this.isLoading.next(false)
  }

}
